import writingAPI from '@/api/writing'

const state = {
  writingCategory: [
    // {
    //   categorySeq: ''
    // },
    {
      categorySeq: 0,
      categoryEnglishExplanation: 'ALL EXPLANATION',
      categoryEnglishName: 'ALL',
      categoryEtcExplanation: '',
      categoryEtcName: '',
      categoryKoreaExplanation: '',
      categoryKoreaName: '전체',
      categoryOrder: 0
    }
  ]
}

const mutations = {
  UPDATE_WRITING_CATEGORIES (pState, payload) {
    // const newArr = [
    //   // ...state.writingCategory,
    //   ...payload
    // ]
    // const all = newArr.splice(newArr.length - 1, 1)
    // newArr.unshift(all[0])

    pState.writingCategory = payload
  }
}
const getters = {
  get_writing_categories: state => state.writingCategory
}

const actions = {
  async getWritingCategory ({ commit, state }) {
    const { data } = await writingAPI.getWritingCategory()

    commit('UPDATE_WRITING_CATEGORIES', [
      ...state.writingCategory,
      ...data
    ])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
